<mat-sidenav-container
  fullscreen
  hasBackdrop="false"
  [ngClass]="{ 'only-desktop': onlyDesktop }"
>
  <mat-sidenav
    #sidenav
    [mode]="isMobile ? 'over' : 'side'"
    [opened]="!isMobile"
    [disableClose]="true"
    [ngClass]="isMobile ? '' : 'mat-drawer-desktop'"
  >
    <app-side-menu
      [sideMenuItems]="sideMenuItems"
      *ngIf="isMobile"
    ></app-side-menu>
    <app-side-menu-desktop
      content
      [sideMenuItems]="sideMenuItems"
      *ngIf="!isMobile"
    ></app-side-menu-desktop>
  </mat-sidenav>
  <mat-sidenav-content>
    <ng-content select="[topHeader]"></ng-content>
    <div class="content">
      <app-banner-notification
        *ngIf="this.authenticatedUserService.bannerData"
        [icon]="'error_outline'"
        [ngClass]="{
          'show-banner': this.authenticatedUserService.bannerData.showBanner
        }"
      ></app-banner-notification>
      <div class="ng-content">
        <ng-content select="[content]"></ng-content>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
